import React, { ComponentProps } from "react";

function WalletIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={21}
      height={18}
      viewBox="0 0 21 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Wallet">
        <path
          id="Wallet_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9688 5.3818H20.2C20.2 1.98459 18.1644 0 14.7155 0H5.6844C2.23551 0 0.199951 1.98459 0.199951 5.33847V12.6615C0.199951 16.0154 2.23551 18 5.6844 18H14.7155C18.1644 18 20.2 16.0154 20.2 12.6615V12.3495H15.9688C14.0052 12.3495 12.4133 10.7975 12.4133 8.883C12.4133 6.96849 14.0052 5.41647 15.9688 5.41647V5.3818ZM15.9688 6.87241H19.4533C19.8657 6.87241 20.2 7.19834 20.2 7.60039V10.131C20.1952 10.5311 19.8637 10.8543 19.4533 10.8589H16.0488C15.0547 10.872 14.1854 10.2084 13.96 9.26432C13.847 8.67829 14.0055 8.07357 14.393 7.61222C14.7805 7.15087 15.3573 6.88007 15.9688 6.87241ZM16.12 9.53298H16.4488C16.871 9.53298 17.2133 9.1993 17.2133 8.78767C17.2133 8.37605 16.871 8.04237 16.4488 8.04237H16.12C15.918 8.04005 15.7236 8.11664 15.5799 8.25504C15.4363 8.39344 15.3555 8.58213 15.3555 8.77901C15.3555 9.19205 15.6963 9.52823 16.12 9.53298ZM4.93773 5.3818H10.5822C11.0044 5.3818 11.3466 5.04812 11.3466 4.63649C11.3466 4.22487 11.0044 3.89119 10.5822 3.89119H4.93773C4.51899 3.89116 4.17815 4.2196 4.17328 4.62783C4.17326 5.04087 4.5141 5.37705 4.93773 5.3818Z"
        />
      </g>
    </svg>
  );
}

export default WalletIcon;
